import { TextField as MuiTextField } from '@mui/material';
import { forwardRef } from 'react';

export const TextField = forwardRef(({ value, onChange, ...props }, ref) => (
  <MuiTextField
    fullWidth
    ref={ref}
    size="small"
    {...props}
    value={value ?? ''}
    onChange={(event) => onChange(event.target.value)}
  />
));

TextField.displayName = 'TextField';
